import { useAtomValue } from "jotai";
import { Text } from "@zapier/design-system";
import { ModalDialog } from "@zapier/design-system-beta";
import { canvasAtom } from "@zapier/canvas-state";

import EditDescriptionModalContent from "./EditDescriptionModalContent";

type Props = {
  onClosed: () => void;
};

export function EditDescriptionModal({ onClosed }: Props) {
  const canvas = useAtomValue(canvasAtom);
  const header = canvas?.description ? "Update description" : "Add description";

  return (
    <ModalDialog.Root isOpen={true} onOpenChange={onClosed} aria-label={header}>
      <ModalDialog.Header>
        <Text type="SectionHeader" margin="0 0 23px 0">
          {header}
        </Text>
      </ModalDialog.Header>
      <ModalDialog.Body>
        <EditDescriptionModalContent onClosed={onClosed} />
      </ModalDialog.Body>
    </ModalDialog.Root>
  );
}
